import { useState } from 'react';
import './LoginContainerComponent.css'

const LoginLocal = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Logging in with:', email, password);
    // May want to change below and add in the local login flow for this. this will send a call to the backend with secured credentials
    setEmail("");
    setPassword("");
  };  
  return (
    <div className="interior-box">
      <form onSubmit={handleSubmit}>
        <h3 style={{ paddingTop: '1rem', margin: '1rem 0rem 0.5rem 0rem', color:"rgb(87, 87, 87)" }}>Email Address</h3>
        <input 
          className="local-login-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <h3 style={{ margin: '1rem 0rem 0.5rem 0rem', color:"rgb(87, 87, 87)" }}>Password</h3>
        <input 
          className="local-login-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="login-button" type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginLocal;